import React, {useRef, useState} from "react";
import '../landingPageStyles.less'
import { FileTextOutlined } from "@ant-design/icons";
import {useAuth0} from "@auth0/auth0-react";
import {DEVELOPERROLE} from "../../../deps";

export const Banner = () => {
  const { loginWithRedirect } = useAuth0();
  const onViewDocs = () => {
   window.open(process.env.REACT_APP_LANDING_PAGE_DOCS_URL)
  };
  const onNavigateSignup = () => {
    loginWithRedirect({
      screen_hint: 'signup',
      appState: { role: DEVELOPERROLE, type: "INDIVIDUAL" },
      userRole: DEVELOPERROLE,
      userType: "INDIVIDUAL",
    });

  };
  return (
    <>
      <div className="Bannersection-wrap" id="home">
        <div className="container">
          <div className="col-md-10 mx-auto banner-head-container">
            <h1 className="banner-heading">
              Accelerate Your Web3 <span className="banner-highlight">Development</span> Journey with Advanced SDKs & APIs
            </h1>
            <p className="banner-para">
              Harness the Power of Advanced Tools for Seamless dApp Development
            </p>
            <div className="banner-button-section">
            <button className="banner_btn" onClick={() => onNavigateSignup()}>
              Get started for free
            </button>
            <button className="docs_btn" onClick={() => onViewDocs()}>
              <span className="banner-docs" ><FileTextOutlined /> View Docs</span>
            </button>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
